import React from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { getApi } from '../../services/apiServices';
import { toast } from 'react-toastify';

function PlanHistoryDetail() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserPlanDetails = async () => {
    if (!userId) {
      setError('User ID is required');
      return;
    }

    setLoading(true);
    setError(null);
    try {
      const response = await getApi(`user-plan-details/${userId}`);

      if (response?.statusCode === 200) {
        setUserDetails(response.data);
      } else {
        setError(response?.message || 'Failed to fetch user plan details');
        console.error('Failed to fetch user plan details:', response?.message);
      }
    } catch (error) {
      setError('Error fetching user plan details. Please try again.');
      console.error('Error fetching user plan details:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserPlanDetails();
  }, [userId]);

  const formatDate = (timestamp) => {
    if (!timestamp || timestamp === "-9223372036854775808") return "N/A";
    const date = new Date(timestamp);
    return date.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  const getStatusText = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Expired";
      case 3:
        return "Cancelled";
      case 4:
        return "Expired";
      default:
        return "Unknown";
    }
  };

  const formatPrice = (price, currency = 'USD') => {
    return `${currency} ${price}`;
  };

  const formatBillingInterval = (interval) => {
    return interval === 'month' ? 'Monthly' : interval === 'year' ? 'Yearly' : interval;
  };

  if (loading) {
    return (
      <div className="right-section">
        <div className="loader-overlay">
          <span className="loader"></span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="right-section">
        <div className="alert alert-danger" role="alert">
          {error}
          <button
            className="btn btn-outline-danger ms-3"
            onClick={() => navigate('/admin/planHistory')}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  if (!userDetails) {
    return (
      <div className="right-section">
        <div className="text-center py-4">No user details found.</div>
      </div>
    );
  }

  const generatePlanHistoryData = () => {
    if (!userDetails.plan_history || userDetails.plan_history.length === 0) {
      return [];
    }

    const sortedHistory = [...userDetails.plan_history].sort((a, b) => b.start_date - a.start_date);
    
    const historyData = [];
    
    historyData.push({
      date: formatDate(userDetails.user_created_at),
      action: "Registered",
      fromPlan: "-",
      toPlan: "Free",
      paymentId: "-",
      status: "Success"
    });

    sortedHistory.forEach((plan, index) => {
      const prevPlan = index < sortedHistory.length - 1 ? sortedHistory[index + 1] : null;
      
      historyData.push({
        date: formatDate(plan.start_date),
        action: prevPlan ? "Upgraded" : "Started",
        fromPlan: prevPlan ? prevPlan.package : "Free",
        toPlan: plan.package,
        paymentId: `TXN-${Math.floor(Math.random() * 9000) + 1000}`,
        status: "Success"
      });
    });

    return historyData;
  };

  const planHistoryData = generatePlanHistoryData();

  return (
    <>
      <div className="right-section">
         <div className="view-heading">
                         <ul>
     
                             <li    onClick={() => navigate('/planHistory')}>
                                 <Link to="/admin/matchManagement" className="active">
                                     <img
                                         src={window.getPublicUrl("/images/back-button.svg")}
                                         alt="Back"
                                     />{" "}
                                     Back to Plan 
                                 </Link>
                             </li>
                             <li className='for-plan-haed'>Plan History for: {userDetails.name}</li>
                         </ul>
                     </div>
     
        {/* <div className="mb-3">
          <button 
            className="btn btn-secondary"
            onClick={() => navigate('/admin/planHistory')}
          > 
            ← Back
          </button>
        </div> */}

       
        {/* <div className="mb-4">
          <h4 className="page-title">Plan History for: {userDetails.name}</h4>
        </div> */}

      
        <div className="customer-tablle-main">
          <table className="table">
            <thead>
              <tr>
                <th className="date" scope="col">Date</th>
                <th className="action" scope="col">Action</th>
                <th className="from-plan" scope="col">From Plan</th>
                <th className="to-plan" scope="col">To Plan</th>
                <th className="payment-id" scope="col">Payment ID</th>
                <th className="status" scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {planHistoryData.length > 0 ? (
                planHistoryData.map((entry, index) => (
                  <tr key={index}>
                    <td className="date">{entry.date}</td>
                    <td className="action">{entry.action}</td>
                    <td className="from-plan">{entry.fromPlan}</td>
                    <td className="to-plan">{entry.toPlan}</td>
                    <td className="payment-id">{entry.paymentId}</td>
                    <td className="status">
                      <button className={`btn btn-status ${entry.status === 'Success' ? 'btn-status-primary' : 'btn-status-expired'}`}>
                        <img 
                          src={window.getPublicUrl(entry.status === 'Success' ? '/images/dot.svg' : '/images/inactive-dots.svg')} 
                          alt={entry.status} 
                        />
                        {entry.status}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center py-4">No plan history found.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default PlanHistoryDetail;